document.addEventListener("DOMContentLoaded", function () {
    const hiddenText = document.getElementById("hidden-text");
    const toggleBtn = document.getElementById("toggle-btn");
    if (!hiddenText || !toggleBtn) return;

    toggleBtn.addEventListener("click", function () {
        const isHidden = hiddenText.classList.contains("hidden");
        if (isHidden) {
            hiddenText.classList.remove("hidden");
            toggleBtn.textContent = " Read less";
        } else {
            hiddenText.classList.add("hidden");
            toggleBtn.textContent = "... Read more";
            window.scrollTo({
                top: toggleBtn.closest("#intro-content-wrapper").offsetTop,
                behavior: "smooth"
            });
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn  = document.getElementById("advanced_search");
  const arrow      = document.getElementById("advanced_arrow");
  const container  = document.querySelector(".search_two");
  if (!toggleBtn || !container || !arrow) return;

  toggleBtn.addEventListener("click", function () {
    const isOpen = container.classList.toggle("advanced-open");
    toggleBtn.setAttribute("aria-expanded", String(isOpen));
    arrow.classList.toggle("open", isOpen);
  });
});